import { Component, OnInit, Input } from '@angular/core';

// env
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-people-photos',
  templateUrl: './people-photos.component.html',
  styles: [
  ]
})
export class PeoplePhotosComponent implements OnInit {

  @Input() dataPeople;
  apiAsset = environment.API_ASSETS;

  constructor() { }

  ngOnInit(): void {
  }

}
